export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/7638e57a825a0af7283e0f5ba749b26f.jpg"
          alt="Technology background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center justify-center px-8 md:px-16 text-center">
        {/* Eyebrow label */}
        <span className="inline-block mb-6 text-xs tracking-[0.3em] uppercase text-amber-300/80 font-medium">
          iOS Platform Experts
        </span>

        {/* Company Name */}
        <h1 className="text-6xl md:text-8xl font-black text-white tracking-tight leading-none mb-4">
          MANI D.O.O
        </h1>

        {/* Divider */}
        <div className="w-20 h-px bg-amber-400 mb-8" />

        {/* Tagline */}
        <p className="text-xl md:text-2xl font-light text-white/80 max-w-2xl leading-relaxed mb-10">
          Developing modern applications for the iOS platform — enhancing user experience and improving the security of mobile devices.
        </p>

        {/* Scroll indicator */}
        <button
          onClick={() => handleScroll("about")}
          className="mt-4 flex flex-col items-center gap-2 text-white/50 hover:text-amber-300 transition-colors cursor-pointer group"
          aria-label="Scroll to about"
        >
          <span className="text-xs tracking-[0.25em] uppercase">Explore</span>
          <div className="w-5 h-8 flex items-center justify-center">
            <i className="ri-arrow-down-line text-lg group-hover:translate-y-1 transition-transform" />
          </div>
        </button>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#F7F5F2] to-transparent" />
    </section>
  );
}
